import { useTranslations } from 'core/hooks'

export const t = key => {
  const translations = useTranslations()
  const [group, name] = key.includes('.') ? key.split('.') : ['basic', key]

  if (!translations?.[group]?.[name]) {
    console.log(`translation [${key} => ${group}.${name}] not found`)
    return key
  }

  return translations[group][name]
}
export const T = ({ children }) => t(children)

export const title = key => t(`titles.${key}`)
export const Title = ({ children }) => title(children)

export const message = key => t(key.includes('.') ? key : `messages.${key}`)
export const Message = ({ children }) => message(children)
